<div class="dashboard-container">
    <ng-container *ngIf="analysis_data_loaded">
        <!-- <p class="subtitle">Opportunities breakdown across – {{commonService.abbreviateNumber(analysis_data['summary']['rules_count'])}} from deterministic rules and {{commonService.abbreviateNumber(analysis_data['summary']['ai_count'])}} from hidden patterns.</p> -->

        <div class="cards-container">
            <div class="metric-card">
                <div class="card-header">
                    <span class="card-title" style="margin-bottom: 0;">Total Opportunities</span>
                    <div class="icon-wrapper">
                        <svg class="card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <circle cx="12" cy="12" r="6"></circle>
                            <circle cx="12" cy="12" r="2"></circle>
                        </svg>
                    </div>
                </div>
                <div class="card-value">{{commonService.abbreviateNumber(analysis_data['summary']['total_count'])}}</div>
                <div class="progress-bar-container">
                    <div class="progress-bar dark" [style.width]="analysis_data['summary']['total_width']"></div>
                </div>
                <!-- <div class="card-footer">Across all</div> -->
            </div>

            <!-- Card 2: Rule Based -->
            <div class="metric-card">
                <div class="card-header">
                    <span class="card-title" style="margin-bottom: 0;">Rule Based</span>
                    <div class="icon-wrapper">
                        <svg class="card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                        </svg>
                    </div>
                </div>
                <div class="card-value">{{commonService.abbreviateNumber(analysis_data['summary']['rules_count'])}}</div>
                <div class="progress-bar-container">
                    <div class="progress-bar green" [style.width]="analysis_data['summary']['rules_width']"></div>
                </div>
                <!-- <div class="card-footer">Top driver &bull; {{analysis_data['summary']['rules_top']}}</div> -->
            </div>

            <!-- Card 3: Hidden Patterns -->
            <div class="metric-card">
                <div class="card-header">
                    <span class="card-title" style="margin-bottom: 0;">AI Triggers</span>
                    <div class="icon-wrapper">
                        <svg class="card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                        </svg>
                    </div>
                </div>
                <div class="card-value">{{commonService.abbreviateNumber(analysis_data['summary']['ai_count'])}}</div>
                <div class="progress-bar-container">
                    <div class="progress-bar orange" [style.width]="analysis_data['summary']['ai_width']"></div>
                </div>
                <!-- <div class="card-footer">Top driver &bull; {{analysis_data['summary']['ai_top']}}</div> -->
            </div>

            <div class="metric-card">
                <div class="card-header">
                    <span class="card-title" style="margin-bottom: 0;">Both Triggers</span>
                    <div class="icon-wrapper">
                        <svg class="card-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                        </svg>
                    </div>
                </div>
                <div class="card-value">{{commonService.abbreviateNumber(analysis_data['summary']['both_count'])}}</div>
                <div class="progress-bar-container">
                    <div class="progress-bar both" [style.width]="analysis_data['summary']['both_width']"></div>
                </div>
                <!-- <div class="card-footer">Top driver &bull; {{analysis_data['summary']['both_top']}}</div> -->
            </div>
        </div>

        <!-- Top Row: Donut Chart & Rule-based Treemap -->
        <div class="grid-row">
            <!-- Donut Chart Card -->
            <div class="card">
                <div class="card-title">Opportunities Breakdown</div>
                <div class="donut-container">
                    <div id="donut-chart"></div>
                    <div class="donut-center-text">
                        <div class="label">Total</div>
                        <!-- <div class="number">{{getTotal(analysis_data['donut_graph']['data'])}}</div> -->
                        <div class="number">{{commonService.abbreviateNumber(analysis_data['summary']['total_count'])}}</div>
                        <div class="label">Opportunities</div>
                    </div>
                </div>
                <div class="legend">
                    <ng-container *ngFor="let legend of analysis_data['donut_graph']['labels']; let index = index;">
                        <div class="legend-item">
                            <div class="val" [style.color]="analysis_data['donut_graph']['colors'][index]">{{(analysis_data['donut_graph']['data'][index]).toLocaleString(APP_CONSTANTS.CURRENCY_FORMAT)}}</div>
                            <div class="lbl">{{analysis_data['donut_graph']['labels'][index]}}</div>
                        </div>
                    </ng-container>
                </div>
            </div>
 
            <div class="card">
                <div class="card-title">Both triggers</div>
                <div #bothTreemap class="treemap-container"></div>
            </div>
        </div>
 
        <div class="grid-row">
 
            <!-- Rule Based Treemap Card -->
            <div class="card" style="margin-bottom: 40px;">
                <div class="card-title">Rule based triggers</div>
                <div #ruleTreemap class="treemap-container"></div>
            </div>
 
            <!-- Hidden Patterns Treemap Card -->
            <div class="card" style="margin-bottom: 40px;">
                <div class="card-title">AI triggers</div>
                <div #hiddenTreemap class="treemap-container"></div>
            </div>
        </div>

        <!-- Middle Row: Hidden Patterns Treemap -->
        <!-- <div class="card" style="margin-bottom: 40px;">
            <div class="card-title">Hidden pattern triggers</div>
            <div #hiddenTreemap class="treemap-container" style="height: 180px;"></div>
        </div> -->

        <!-- Bottom Row: Sankey Diagram -->
        <div class="card sankey-card">
            <div class="card-title">Chain of analysis - {{analysis_data['tree_graph']['nodes'][0]['name']}} ({{commonService.abbreviateNumber(analysis_data['summary']['total_count'])}})</div>
            <!-- <p style="font-size: 12px; color: #64748b; margin-top:0;">Every opportunity traced from its source to the trigger that produced it. Send thickness equals volume — hover a band to isolate its path.</p> -->
            <div class="sankey-wrapper">
                <div #sankeyDiagram class="sankey-container"></div>
            </div>
        </div>
    </ng-container>
</div>

<ng-container *ngIf="!analysis_data_loaded">
    <app-loader [loading_text]="'Loading Analysis'"></app-loader>
</ng-container>